export default {
    OrderPostage: {
        name: '文件名称',
        time: '发票生成时间',
        type: '类型',
        create: '创建时间',
        not: '不匹配项目',
        order: '运单号',
        price: '发票价格',
        yet: '匹配项目',
        outer: '平台订单号',
        logitisic: '物流运单号',
        lose: '差异百分比',
        over: '差值',
        total: '总价格',
        pay: '发票总和金额',
        fee: '发票收费明细',
        Freight: '运费',
        tax: '运费税',
        cost: '燃油费',
        Fuel: '燃油税',
        ERP: 'ERP收费明细',
        Totals: '总税额',
        amount: '总金额',
        diff: '差值超过',
        after: '税前总金额',
        ExtraTax: '税前额外费',
        taxsurcharge: '税前超重费',
        taxextra: '税前超长费',
        taxreturn: '税前退回重发费',
        invoiceNotes: '备注',
    },
    IntegratedPage: {
        id: '商品ID',
        name: '商品名称',
        key: '关键字',
        rank: '排名',
        sale: '卖家',
        type: '类型',
        typeS: '销售类型',
        self: '链接',
        doll: '金额',
        dollS: '金额单位',
        save: '节省金额',
        saveS: '节省金额单位',
        star: '星级',
        num: '评论数量',
        typeSS: '特殊类型',
    }
};
